import { Component, ElementRef, ViewChild} from '@angular/core';
import { NavController, NavParams,Platform } from 'ionic-angular';


declare var google: any;

@Component({
  selector: 'page-consumer-nearby',
  templateUrl: 'consumer-nearby.html',
})
export class ConsumerNearbyPage {
	@ViewChild('mapCanvas') mapElement: ElementRef;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams, 
		public platform: Platform,
	) {
		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerNearbyPage');
		this.loadMap();
	}

	loadMap() {
        let mapEle = this.mapElement.nativeElement;

        let map = new google.maps.Map(mapEle, {
          center: {lat: 43.0741904, lng: -89.3809802},
          zoom: 16
        });		

        console.log('=======map=======');
        console.log(map)

		// // make sure to create following structure in your view.html file
		// // and add a height (for example 100%) to it, else the map won't be visible
		// // <ion-content>
		// //  <div #map id="map" style="height:100%;"></div>
		// // </ion-content>

		// // create a new map by passing HTMLElement
		// let element: HTMLElement = document.getElementById('map_canvas');

		// let map: GoogleMap = this.googleMaps.create(element);

		// // listen to MAP_READY event
		// // You must wait for this event to fire before adding something to the map or modifying it in anyway
		// map.one(GoogleMapsEvent.MAP_READY).then(
		// () => {
		//  console.log('Map is ready!');
		//  // Now you can add elements to the map like the marker
		// }
		// );

		// // create LatLng object
		// let ionic: LatLng = new LatLng(43.0741904,-89.3809802);

		// // create CameraPosition
		// let position: CameraPosition = {
		// 	target: ionic,
		// 	zoom: 18,
		// 	tilt: 30
		// };

		// // move the map's camera to position
		// map.moveCamera(position);

		// // // create new marker
		// // let markerOptions: MarkerOptions = {
		// // 	position: ionic,
		// // 	title: 'Ionic'
		// // };

		// // const marker: Marker = map.addMarker(markerOptions)
		// // .then((marker: Marker) => {
		// //   	marker.showInfoWindow();
		// // });		
	}

}



// WEBPACK FOOTER //
// ./src/pages/consumer-nearby/consumer-nearby.ts